export const GET_PROFILE_API = 'getProfile'; // not in use
export const GET_BASE_URL = 'https://mousewait.com/backend';
// export const GET_BASE_URL = 'http://localhost/MWBACKEND';
export const GET_BASE_URL_IMAGE = 'https://mousewait.com';
// Editor-inserted photos (uploadImage) always live here, including WDW.
// WDW post attachments use /disneyworld/chat_images/{chat_id}_c_img.jpg.
export const LAND_CHAT_IMAGE_DIR = GET_BASE_URL_IMAGE + '/disneyland/chat_images/';
export const GET_URL_PART = 'mousewaitnew';
export const GET_MINI_DATA = '.slice(0, 10).join(" ")';
export const dTime = '?' + Date.now();
export const LOCAL_BASE_URL = 'http://localhost/mousewaitnew';
